import logoSrc from 'images/login_logo.png';

export default class RestorePasswordController {
  constructor(RestorePassword) {
    'ngInject';

    this.logoSrc = logoSrc;
    this.RestorePassword = RestorePassword;
    this.recoveryData = {};
    this.errors = [];
  }

  handlePasswordRestoring(recoveryData) {
    this.errors = [];

    this.isInstructionsSent = true;
    this.RestorePassword.sendRequest(recoveryData)
      .catch((response) => {
        this.isInstructionsSent = false;
        this.errors = response.data.errors;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/restore-password/restore-password.controller.js